<img class="logo" [src]="(isCabangaLite$ | async) ? 'assets/img/logo-scolares.png' : 'assets/img/logo.png'" />
<div class="full-screen">
  <div>
    <div class="flex content-center items-none gap-10px flex-row">
      <div class="flex flex-row">
        @if ((school$ | async)?.logoLink; as logoLink) {
          <img alt="logo de l'école" [src]="logoLink" class="flex self-start school-logo">
        }
      </div>
      <div class="flex flex-column">
        @if (!isSuperAdmin) {
          <h3>
            {{schoolName$ | async}}
          </h3>
        }
        @if (!isSuperAdmin) {
          <h3>
            {{firstName$ | async}} {{lastName$ | async}}
          </h3>
        }
        <div class="flex flex-column mat-h4">
          @if (activeSchoolYear$ | async; as activeSchoolYear) {
            <div>
              <app-school-year [year]="activeSchoolYear"></app-school-year>
            </div>
          }
        </div>
      </div>
    </div>

    <div>
      <app-public-message
        [publicMessage]="publicMessage$ | async"
        [isAdminStaffMember]="isAdminStaffMember$ | async"
        (publicMessageSave)="savePublicMessage($event)">
      </app-public-message>

      @if (isCabangaLite$ | async) {
        <app-lite-school-shortcuts
          [isTeacherOrEducatorStaffMember]="isTeacherOrEducatorStaffMember$ | async">
        </app-lite-school-shortcuts>
      } @else if (isElementarySchool$ | async) {
        <app-elementary-school-shortcuts
          [isTeacherOrEducatorStaffMember]="isTeacherOrEducatorStaffMember$ | async"
          [isTeacherStaffMember]="isTeacherStaffMember$ | async"
          [isStaffMember]="isStaffMember$ | async">
        </app-elementary-school-shortcuts>
      } @else {
        <app-secondary-school-shortcuts
          [isTeacherOrEducatorStaffMember]="isTeacherOrEducatorStaffMember$ | async"
          [isTeacherStaffMember]="isTeacherStaffMember$ | async"
          [isStaffMember]="isStaffMember$ | async">
        </app-secondary-school-shortcuts>
      }
      @if ((isParent$ | async) && (parentMeetingSlots$ | async)?.length > 0) {
        <div class="container-card">
          <h2>Vos réunions de parents</h2>
          <app-parent-meeting-slot-list
            [readonly]="true"
            [parentMeetingSlots]="parentMeetingSlots$ | async"
          [isMobile]="isMobile$ | async"></app-parent-meeting-slot-list>
        </div>
      }
    </div>
  </div>

  @if (!(isCabangaLite$ | async)) {
  <div>
    <h2>Activités</h2>
    <div class="flex flex-1 content-space-around items-none flex-column">
      @for (day of businessDays; track day; let i = $index) {
        <div class="flex flex-1 flex-column">
          <div class="flex gap-15px flex-row">
            <div class="flex flex-30">
              <div class="flex content-end items-none day">{{getDay(day)}}</div>
              <div class="flex content-end items-none month">{{getMonth(day)}}</div>
            </div>
            <mat-chip-listbox>
              @for (activity of getActivities$(day) | async; track activity; let j = $index) {
                <mat-chip highlighted
                [attr.data-cy]="'activity-cell-' + i + '-' + j">{{activity.activity}}</mat-chip>
              }
            </mat-chip-listbox>
          </div>
          <mat-divider></mat-divider>
        </div>
      }
    </div>
  </div>
  }
</div>
